import { connect } from "react-redux";
import ErrorPage from "@containers/ErrorPage";
import CatalogResealedList from "@containers/Catalog/ResealedList";
import withRouterPageLayout from "@components/withRouterPageLayout.js";
import PromoToasts from "@components/PromoToasts";
import { extractFiltersParams } from "@lib/filterUtil";
import {
  getCategoryResealed,
  getCategoryResealedTree,
} from "@store/resealed/actions";

// TODO: MEGA FUCKING WARNING!!
// MAKE SURE TO KEEP THINGS IN SYNC AT THE MOMENT
// resigilate/[[...filters]].js
// resigilate/[urlKey]/cpl/[[...filters]].js

const List = ({ currentCategory }) => {
  if (currentCategory?.category) {
    return (
      <>
        <CatalogResealedList />

        <PromoToasts
          type="category"
          params={{ categoryId: currentCategory?.category?.id }}
        />
      </>
    );
  }

  return <ErrorPage layout="404" />;
};

List.getInitialProps = async ({ reduxStore, query, res }) => {
  // TODO: We manually remove filtru slug from the router
  // because we have a catch all ([[...filters]]) route
  // Important: Some filters can be named "filtru"
  // URL: /accesorii-consumabile-electrocasnice-mari/cpl/filtru/tip-produs-8434/filtru/
  // query.filters: /filtru/tip-produs-8434/filtru/
  const queryFilters = query.filters || [];

  const filterPrefixIndex = queryFilters.findIndex(
    (queryFilter) => queryFilter === "filtru"
  );

  if (filterPrefixIndex === 0) {
    queryFilters.shift();
  }

  const extractedFiltersParams = extractFiltersParams(queryFilters);

  // Set the default number of items to bring
  extractedFiltersParams.apiQueryParams = `${
    extractedFiltersParams.apiQueryParams
  }${extractedFiltersParams.apiQueryParams === "" ? "?" : "&"}size=48`;

  await reduxStore.dispatch(getCategoryResealedTree());

  const categoryProducts = await reduxStore.dispatch(
    getCategoryResealed(query, extractedFiltersParams)
  );

  if (res && !categoryProducts) {
    res.statusCode = 404;
  }
};

List.pageLayout = "default";

export default withRouterPageLayout(
  connect((state) => ({
    currentCategory: state.resealed.currentCategory,
  }))(List)
);
